<template>
  <div class="data-management-contents">
    <div>
      <b-row>
        <b-colxx xxs="12">
          <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>
      <!-- Study dropdown groups -->
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0 pr-0">
          <header-drop-down-filter
            :leftHeaderText="leftHeaderTextValue"
            :sites="allSitesList"
            :countries="countryList"
            :callApiCompleted="callApiCompleted"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
            :exportBtn="true"
            :participantsBtn="true"
            @onApplyCountry="getDataFromRadioButton"
            @onApplySites="getDataFromCheckbox"
            @onApplyParticipants="getParticipantsDataFromCheckbox"
            @onFetchedParticipants="fetchedParticipants"
            @onApplyFpi="filter"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"
            v-if="studyData"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            :toggleFeatures="toggleFeatures"
            :studyData="studyData"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>
      <DataManagementInsightCard
        :datasources="{
          overallCollectionMetricRaw,
          totalQuery,
          totalDataChange
        }"
        v-if="complianceWidgets"
        :dataLoaded="dataLoaded.overallCollectionMetricRaw && dataLoaded.totalQuery && dataLoaded.totalDataChange"
        :participantsSelected="participantsSelected"
        :countries="countrySelected == 'all' ? countryList : countrySelected"
        :sites="sitesSelected == 'all' ? allSitesList : sitesSelected"
      ></DataManagementInsightCard>
      <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        Back
      </div>
      <!-- Top cards -->
      <!-- Section 1 -->
      <b-row class="pb-10" v-show="zoomGraphValue === ''">
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6">
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong">Percentage of Queries Open</div>
            </b-card-header>
            <div class="data-card-center height-100">
              <div v-if="queriesSeries.open && queriesSeries.open !== 'NaN'" class="number-text">{{ queriesSeries.open }}%</div>
              <div v-else class="align-center">
                <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                  No Data In
                </div>
                <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
              </div>
            </div>
          </b-card>
        </b-colxx>
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6">
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong">
                Percentage of Queries Responded
              </div>
            </b-card-header>
            <div class="data-card-center height-100">
              <div v-if="queriesSeries.response && queriesSeries.response !== 'NaN'" class="number-text">{{ queriesSeries.response }}%</div>
              <div v-else class="align-center">
                <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                  No Data In
                </div>
                <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
              </div>
            </div>
          </b-card>
        </b-colxx>
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6">
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong">Percentage of Queries Closed</div>
            </b-card-header>
            <div class="data-card-center height-100">
              <div v-if="queriesSeries.closed && queriesSeries.closed !== 'NaN'" class="number-text">{{ queriesSeries.closed }}%</div>
              <div v-else class="align-center">
                <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                  No Data In
                </div>
                <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
              </div>
            </div>
          </b-card>
        </b-colxx>
        <b-colxx xl="3" lg="12" md="12" class="pl-0 pb-6 pr-0">
          <b-card class="custom-card white-bg">
            <b-card-header>
              <div class="card-text-strong">Average Time to Query Closed</div>
            </b-card-header>
            <div class="data-card-center height-100" v-if="queriesTimeSeries && queriesTimeSeries.value && !viewNoDataIn">
              <div class="number-text">
                {{ queriesTimeSeries.value.d }}
                <span class="small-text-custom">{{ queriesTimeSeries.value.d != 1 ? "days" : "day" }}</span>
                {{ queriesTimeSeries.value.h }}<span class="small-text-custom">hrs</span>
              </div>
              <div class="container-label">
                <div class="flex-column">Longest Activity</div>
                <div class="flex-column-value add-tooltip">
                  {{ queriesTimeSeries.name }}
                </div>
                <div class="custom-tooltip hidden-text-custom text-right-value">
                  <div>{{ queriesTimeSeries.name }}</div>
                </div>
              </div>
            </div>
            <div v-else class="align-center">
              <div class="card-text-title no-data" v-if="dataLoaded && dataLoaded.queriesRaw">
                No Data In
              </div>
              <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
            </div>
          </b-card>
        </b-colxx>
      </b-row>
      <!-- END OF SECTION 1 -->

      <!-- SECTION 2 -->
      <!-- Overall Data Collection with Completion Metrics   -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-data-collection-metrics'" v-if="complianceWidgets">
        <b-colxx class="pl-0 pb-6 pr-0" xl="12" lg="12" md="12" :class="zoomGraphValue === 'overall-data-collection-metrics' ? 'overall-data-collection-metrics-zoom' : ''" style="transition-duration: 0.2s">
          <OverallCollectionMetrics
            :siteListInParticipants="siteListInParticipants"
            :collectionMetricsRaw="overallCollectionMetricRaw"
            :participantRaw="overallCollectionMetricParticipantRaw"
            :filterTriggered="filterTriggered"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :specificSiteId="specificSiteId"
            :customType="'scrollstackedcolumn2d'"
            :zoomGraphValue="zoomGraphValue"
            :listParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.overallCollectionMetricRaw"
            v-on:zoomEnabled="zoomGraphValue = 'overall-data-collection-metrics'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            titleChart="Overall Data Collection with Completion Metrics"
          >
          </OverallCollectionMetrics>
        </b-colxx>
      </b-row>
      <!-- Overall Data Collection with Completion Metrics   -->
      <!-- END OF SECTION 2 -->

      <!-- SECTION 3 -->
      <!-- OVERALL MISSING DATA & DATA QUERIES  -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-data-queries' || zoomGraphValue === 'overall-missing-data'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-missing-data'" v-if="complianceWidgets" :class="zoomGraphValue === 'overall-missing-data' ? 'col-xl-12 overall-missing-data-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s">
          <OverallMissingDataCard
            titleChart="Overall Missing Data"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'overall-missing-data'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :rawSeries="overallMissingRaw"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="allSitesList"
            :dataLoaded="dataLoaded.overallMissingRaw"
          />
        </b-colxx>
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-data-queries'" :class="zoomGraphValue === 'overall-data-queries' ? 'col-xl-12 overall-data-queries-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6 pr-0" style="transition-duration: 0.2s">
          <LineChart
            titleChart="Data Queries"
            downloadId="overall-data-queries-zoom"
            xAxisName="Days"
            yAxisName="Number of Queries"
            tooltip="Queries"
            :tab="tabQueries"
            :data="queriesData"
            containerId="blank"
            v-on:zoomEnabled="zoomGraphValue = 'overall-data-queries'"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :dataLoaded="dataLoaded.queriesRaw"
          >
            <span class="float-right enrol-tabs">
              <b-tabs v-model="tabQueries">
                <b-tab v-for="(tabName, index) in tabListTotalAndPercentage" :key="index" :title="tabName" />
              </b-tabs>
            </span>
          </LineChart>
        </b-colxx>
      </b-row>
      <!-- OVERALL MISSING DATA & DATA QUERIES  -->
      <!-- END OF SECTION 3 -->

      <!-- SECTION 4 -->
      <!-- QUERY STATUS & TOP 5 QUERIES CHART  -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-query-status'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'overall-query-status'" :class="zoomGraphValue === 'overall-query-status' ? 'col-xl-12 overall-query-status-zoom' : 'col-xl-6'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s">
          <QueryStatusBar
            :filterTriggered="filterTriggered"
            titleChart="Query Status"
            class="overall-query-status"
            downloadId="overall-query-status"
            :tabListOverallQueryStatus="tabListOverallQueryStatus"
            yAxisName="Total per Status"
            :queriesRaw="queriesRaw"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :zoomGraphValue="zoomGraphValue"
            :dataLoaded="dataLoaded.queriesRaw"
            v-on:zoomEnabled="zoomGraphValue = 'overall-query-status'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
          >
          </QueryStatusBar>
        </b-colxx>
        <b-colxx v-show="zoomGraphValue === ''" xl="6" lg="12" md="12" class="pl-0 pb-6 pr-0">
          <Top5Queries :filterTriggered="filterTriggered" downloadId="top-five-queries-p2-id" titleChart="Top 5 Queries" :queriesRaw="queriesRaw" :dataLoaded="dataLoaded.queriesRaw" :specificSiteId="specificSiteId" :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected" :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected">
          </Top5Queries>
        </b-colxx>
      </b-row>
      <!-- QUERY STATUS & TOP 5 QUERIES CHART  -->
      <!-- END OF SECTION 4 -->

      <!-- SECTION 5 -->
      <!-- AVERAGE TIME  -->
      <!-- TODO YOUR LOGIC -->
      <average-time-cards :zoomGraphValue="zoomGraphValue" :activitiesRaw="activitiesRaw" :filterTriggered="filterTriggered" :dataLoaded="dataLoaded.activitiesRaw" :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected" :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"> </average-time-cards>
      <!-- AVERAGE TIME  -->
      <!-- END OF SECTION 5 -->

      <!-- SECTION 6 -->
      <!-- Time to Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'time-activities-status'">
        <!-- TODO YOUR LOGIC -->
        <b-colxx :class="zoomGraphValue === 'time-activities-status' ? 'time-activities-status-zoom' : ''" xl="12" lg="12" md="12" class="pl-0 pb-6 pr-0" style="transition-duration: 0.2s">
          <TimeToActivitiesStatusCard
            :activitiesRaw="activitiesRaw"
            :filterTriggered="filterTriggered"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :tabListActCountSit="tabListActCountSit"
            containerId="blank"
            v-on:zoomEnabled="zoomGraphValue = 'time-activities-status'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            titleChart="Time to Activity Status (Entry Completed/Approved/Verified/Signed Off)"
            downloadId="time-activities-status"
            :dataLoaded="dataLoaded.activitiesRaw"
          >
          </TimeToActivitiesStatusCard>
        </b-colxx>
      </b-row>
      <!-- Time to Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->
      <!-- END OF SECTION 6 -->

      <!-- SECTION 7 -->
      <!-- Percentage of Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'percentage-activities'">
        <b-colxx :class="zoomGraphValue === 'percentage-activities' ? 'percentage-activities-zoom' : ''" xl="12" lg="12" md="12" class="pl-0 pb-6 pr-0" style="transition-duration: 0.2s">
          <TimeActivitiesPercentage
            :activitiesRaw="activitiesRaw"
            :filterTriggered="filterTriggered"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :tabListActCountSit="tabListActCountSit"
            v-on:zoomEnabled="zoomGraphValue = 'percentage-activities'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            titleChart="Percentage of Activity Status (Entry Completed/Approved/Verified/Signed Off)"
            downloadId="percentage-activities"
            :dataLoaded="dataLoaded.activitiesRaw"
          >
          </TimeActivitiesPercentage>
        </b-colxx>
      </b-row>
      <!-- Percentage of Activity Status (Entry Completed/Approved/Verified/Signed Off)  -->
      <!-- END OF SECTION 7 -->

      <!-- SECTION 8 -->
      <!-- FORM STATUS  -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'form-status'">
        <!-- TODO YOUR LOGIC -->
        <b-colxx :class="zoomGraphValue === 'form-status' ? 'col-xl-12 form-status-zoom' : 'col-xl-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'form-status'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 0.2s">
          <FormStatusCard
            :filterTriggered="filterTriggered"
            titleChart="Form Status"
            downloadId="form-status"
            class="form-status"
            xAxisName="Days"
            yAxisName="Total per Status"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :formStatusRaw="formStatusRaw"
            :zoomGraphValue="zoomGraphValue"
            :dataLoaded="dataLoaded.formStatusRaw"
            v-on:zoomEnabled="zoomGraphValue = 'form-status'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
          ></FormStatusCard>
        </b-colxx>
        <b-colxx xl="6" lg="12" md="12" class="pl-0 pb-6 pr-0" v-show="zoomGraphValue === ''">
          <TopTimeActivity
            :filterTriggered="filterTriggered"
            titleChart="Top 5 Longest Time to Status"
            downloadId="topFivelongest-p2-id"
            :countrySelected="this.countrySelected === 'all' ? this.countryList : this.countrySelected"
            :sitesSelected="this.sitesSelected[0] === 'all' ? this.allSitesList : this.sitesSelected"
            :tabListTopTimeStatus="tabListTopTimeStatus"
            :activitiesRaw="activitiesRaw"
            :specificSiteId="specificSiteId"
            :dataLoaded="dataLoaded.activitiesRaw"
          >
          </TopTimeActivity>
        </b-colxx>
      </b-row>
      <!-- FORM STATUS  -->
      <!-- END OF SECTION 8 -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import _get from "lodash/get";
import moment from "moment";
import { mapGetters } from "vuex";
import HeaderDropDownFilter from "../form-components/header-drop-down-filter";
import Loading from "vue-loading-overlay";
import * as srv from "../../services/visualization/data-management";
import OverallCollectionMetrics from "../containers/overall-collection-metrics";
import * as ocm from "../../services/visualization/data-management-overall-collection";
import TimeToActivitiesStatusCard from "../containers/time-to-activities-status-card";
import Top5Queries from "../containers/top-5-queries";
import LineChart from "../charts/fusion/line";
import QueryStatusBar from "../containers/query-status-bar";
import FormStatusCard from "../containers/form-status.card";
import TimeActivitiesPercentage from "../containers/time-activities-percentage";
import TopTimeActivity from "../containers/top-time-activity";
import * as dManagement from "../../services/visualization/new-data-management";
import OverallMissingDataCard from "../containers/overall-missing-data-card";
import "vue-loading-overlay/dist/vue-loading.css";
import { ACTIVITIES, COUNTRIES, PARTICIPANTS, SITES } from "@/constants/config";
import AverageTimeCards from "@/components/containers/average-time-cards";
import DataManagementInsightCard from "@/components/containers/data-management-insights-card";
import * as utils from "../../services/visualization/utils";
import * as commonHelper from "@/components/services/common-helper";
const visible = "10";

Vue.use(Loading);

const convertArrToString = arrObj => {
  let resultString = ``;
  if (arrObj && arrObj.length > 0) {
    arrObj.forEach(o => {
      resultString += `${o},`;
    });
    resultString = resultString.slice(0, -1);
  }
  return resultString;
};

export default {
  components: {
    AverageTimeCards,
    LineChart,
    QueryStatusBar,
    HeaderDropDownFilter,
    OverallCollectionMetrics,
    TimeToActivitiesStatusCard,
    Top5Queries,
    FormStatusCard,
    TimeActivitiesPercentage,
    TopTimeActivity,
    OverallMissingDataCard,
    DataManagementInsightCard
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    complianceWidgets: { type: Boolean, default: false },
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      studyId: null,
      filterTriggered: false,
      tabList: [],
      TABS: index => {
        const defaultTab = {
          name: "default",
          visible
        };
        return this.tabList[index] || defaultTab;
      },
      countryList: [],
      allSitesList: [],
      participantRaws: [],
      participantList: [],
      siteListInParticipants: [],
      sitesSelected: ["all"],
      participantsSelected: ["all"],
      callApiCompleted: null,
      countrySelected: "all",
      studySelected: null,
      studyList: null,
      leftHeaderTextValue: "Data Management Dashboard",
      monthSelected: [],
      fromDate: null, //fromDate and toDate is a string value for date filter. Format would be YYYY-MM-DD
      toDate: null,
      overallCollectionMetricWithFilteredData: {},
      overallCollectionMetricRaw: {},
      overallCollectionMetricParticipantRaw: {},
      percentageOfActivityStatusRaw: null,
      timeToActivitiesStatusCardRaw: null,
      timeToActivitiesStatusCardSeries: null,
      tabIndexTimeToActivities: 0,
      dataPicker: [],
      valueAvgQueryClose: 0,
      queriesSeries: {},
      tabOverallMissing: 0,
      tabQueries: 0,
      overallMissingRaw: null,
      queriesData: [],
      timeActivityRaw: null,
      queriesRaw: null,
      activitiesRaw: null,
      tabFormStatusCard: 0,
      formStatusRaw: null,
      queriesTimeRows: null,
      queriesTimeSeries: null,
      zoomGraphValue: "",
      specificSiteId: null, // you will get specific ID if you're not SystemAdmin
      tabListTotalAndPercentage: ["Total", "Percentage"],
      tabListOverallQueryStatus: ["Day Ranges", "Activities"],
      tabListTopTimeStatus: ["Entry Completed", "Approved", "Verified", "Signed Off"],
      tabListActCountSit: ["Activities", "Countries"],
      loader: null,
      isLoading: true,
      tmpCountries: [],
      tmpSites: [],
      dataLoaded: {},
      totalQuery: null,
      totalDataChange: null,
      viewNoDataIn: false,
      sitesDetails: [],
      allApiCountries: [],
      allApiSites: [],
      newCountries: [],
      newSites: []
    };
  },
  methods: {
    getOverallCollectionMetricWithFilteredData() {
      let accumulationTotalComplete = 0;
      let accumulationTotalMissing = 0;
      let accumulationTotalCompletePrevWeek = 0;
      let accumulationTotalMissingPrevWeek = 0;

      const selectedCountries = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const selectedSites = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;
      Object.keys(this.overallCollectionMetricRaw).forEach(activityKey => {
        const activity = this.overallCollectionMetricRaw[activityKey];
        selectedCountries.forEach(country => {
          selectedSites.forEach(site => {
            const data = activity[country][site];

            accumulationTotalComplete += parseInt(data.nTotalCompleted || 0);
            accumulationTotalMissing += parseInt(data.nTotalMissing || 0);
            accumulationTotalCompletePrevWeek += parseInt(data.nTotalCompletedPrev1Week || 0);
            accumulationTotalMissingPrevWeek += parseInt(data.nTotalMissingPrev1Week || 0);
          });
        });
      });

      this.overallCollectionMetricWithFilteredData = {
        accumulationTotalComplete,
        accumulationTotalMissing,
        accumulationTotalCompletePrevWeek,
        accumulationTotalMissingPrevWeek,
        missingDataPercentage: accumulationTotalMissing ? (accumulationTotalMissing / (accumulationTotalComplete + accumulationTotalMissing)) * 100 : 0
      };
    },
    getNewQueries(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.queriesList && this.queriesList.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.queriesList.body;
        if (result.data && "activities" in result.data) {
          response = result.data.activities;
          this.setNewQueriesData(response, filterBy);
        }
      } else {
        this.$api.getQueriesEndpoint(params).then(data =>{
          if (data.ok) {
            const result = data.body;
            this.$store.dispatch("saveQueriesData", data);
            this.$store.dispatch("saveStudyId", this.studyId);
            if (result.data) {
              if ("activities" in result.data) {
                response = result.data.activities;
                this.setNewQueriesData(response, filterBy);
              }
            }
          }
        });
      }
      this.isLoading = false;
      return response;
    },
    getNewActivities(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.activitiesData && this.activitiesData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.activitiesData.body;
        if (result.data && "activities" in result.data) {
          response = result.data.activities;
          this.setNewActivitiesData(response, filterBy);
        }
      } else {
        this.$api.getActivitiesEndpoint(params).then( data=>{
          if (data.ok) {
          const result = data.body;
            this.$store.dispatch("saveActivitiesData", data);
            this.$store.dispatch("saveStudyId", this.studyId);
            if (result.data) {
              if ("activities" in result.data) {
                response = result.data.activities;
                this.setNewActivitiesData(response, filterBy);
              }
            }
          }
        });
      }
      this.isLoading = false;
      return response;
    },
    getNewFormStatus(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.formStatusData && this.formStatusData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.formStatusData.body;
        if (result.data && "locations" in result.data) {
          response = result.data.locations;
          this.setFormStatusData(response, filterBy);
        }
      } else {
        this.$api.getFormStatusEndpoint(params).then(data =>{
          if (data.ok) {
            const result = data.body;
            this.$store.dispatch("saveFormStatusData", data);
            this.$store.dispatch("saveStudyId", this.studyId);
            if (result.data) {
              if ("locations" in result.data) {
                response = result.data.locations;
                this.setFormStatusData(response, filterBy);
              }
            }
          }
        });
      }
      this.isLoading = false;
      return response;
    },
    getNewQueriesTime(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (!(this.countrySelected[0] === "all" || this.countrySelected === "all")) {
        const countryIds = utils.getCountryIds(this.countrySelected, this.sitesDetails);
        params.countryIds = utils.convertArrToString(countryIds);
      }

      if (this.sitesSelected[0] !== "all") {
        const siteIds = utils.getSiteIds(this.sitesSelected, this.sitesDetails);
        params.siteIds = utils.convertArrToString(siteIds);
      }
      if (this.queriesTimeList && this.queriesTimeList.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.queriesTimeList.body;
        if (result.data && "locations" in result.data) {
          response = result.data.locations;
          this.setQueriesTimeData(response, filterBy);
        }
      } else {
        this.$api.getQueriesTimeEndpoint(params).then(data =>{
          if (data.ok) {
            const result = data.body;
            this.$store.dispatch("saveQueriesTimeData", data);
            this.$store.dispatch("saveStudyId", this.studyId);
            if (result.data) {
              if ("locations" in result.data) {
                response = result.data.locations;
                this.setQueriesTimeData(response, filterBy);
              }
            }
          }
        })
      }
      this.isLoading = false;
      return response;
    },
    getNewOverallCollection(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        if (this.overallCollectionData && this.overallCollectionData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
          const result = this.overallCollectionData.body;
          if (result.data && "activities" in result.data) {
            response = result.data.activities;
            this.setOverallColectionData(response, filterBy);
          }
        } else {
          this.$api.getOverallColectionEndpoint(params).then(data =>{
            if (data.ok) {
              const result = data.body;
              this.$store.dispatch("saveOverallCollectionData", data);
              this.$store.dispatch("saveStudyId", this.studyId);
              if (result.data) {
                if ("activities" in result.data) {
                  response = result.data.activities;
                  this.setOverallColectionData(response, filterBy);
                }
              }
            }
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getNewOverallCollectionParticipant(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }

      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }
      if (this.overallCollectionParticipantData && this.overallCollectionParticipantData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
          const result = this.overallCollectionParticipantData.body;
          if (result.data && "locations" in result.data) {
            response = result.data.locations;
            this.setOverallColectionParticipantData(response, filterBy)
          }
      } else {
        this.$api.getOverallColectionParticipantEndpoint(params).then(data =>{
          if (data.ok) {
            const result = data.body;
            this.$store.dispatch("saveOverallCollectionParticipantData", data);
            this.$store.dispatch("saveStudyId", this.studyId);
            if (result.data) {
              if ("locations" in result.data) {
                response = result.data.locations;
                this.setOverallColectionParticipantData(response, filterBy)
              }
            }
          }
        });
      }
      this.isLoading = false;
      return response;
    },
    getOverallMissingData(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        if (this.overallCollectionMissingData && this.overallCollectionMissingData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
          const result = this.overallCollectionMissingData.body;
          if (result.data && "locations" in result.data) {
            response = result.data.locations;
            this.setOverallColectionMissingData(response, filterBy);
          }
        } else {
          this.$api.getOverallColectionMissingEndpoint(params).then(data =>{
            if (data.ok) {
              const result = data.body;
              this.$store.dispatch("saveOverallCollectionMissingData", data);
              this.$store.dispatch("saveStudyId", this.studyId);
              if (result.data) {
                if ("locations" in result.data) {
                  response = result.data.locations;
                  this.setOverallColectionMissingData(response, filterBy);
                }
              }
            }
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getTotalQueryEndpoint(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        if (this.totalQueryData && this.totalQueryData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
          const result = this.totalQueryData.body;
          if (result.data && "locations" in result.data) {
            response = result.data.locations;
            this.setTotalQueryData(response, filterBy);
          }
        } else {
          this.$api.getTotalQuery(params).then(data =>{
            if (data.ok) {
              this.$store.dispatch("saveTotalQueryData", data);
              this.$store.dispatch("saveStudyId", this.studyId);
              response = _.get(data, "body.data.locations", null);
              this.setTotalQueryData(response, filterBy);;
            }
          })
        }
        this.isLoading = false;
        return response;
      }
    },
    getTotalDataChangeEndpoint(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if (this.fromDate) {
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }
        if (this.participantsSelected && this.participantsSelected[0] !== "all") {
          params.participantsIds = convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        if (this.totalDataChangeData && this.totalDataChangeData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
          const result = this.totalDataChangeData.body;
          if (result.data && "locations" in result.data) {
            response = result.data.locations;
            this.setDataChange(response, filterBy);
          }
        } else {
          this.$api.getDataChange(params).then(data =>{
            if (data.ok) {
              this.$store.dispatch("saveTotalDataChangeData", data);
              this.$store.dispatch("saveStudyId", this.studyId);
              response = _.get(data, "body.data.locations", null);
              this.setDataChange(response, filterBy);
            }
          });
        }
        this.isLoading = false;
        return response;
      }
    },
    getSiteDetails() {
      if (this.sitesData && this.sitesData.length > 0 && this.checkCurrentSiteOrStudy) {
        this.sitesDetails = this.sitesData;
        return this.sitesData;
      } else {
        let response = [];
        this.$api.getSitesFact(this.studyId).then(responseData =>{
          if (responseData.ok) {
            response = _get(responseData, "body", null);
            this.$store.dispatch("saveSitesData", response);
            this.$store.dispatch("saveStudyId", this.studyId);
            commonHelper.setSiteId();
            this.sitesDetails = response;
            return response;
          }
        });
      }
    },
    generateAxisTimeActivities(tab = 0) {
      let axisName = "";
      switch (tab) {
        case 0:
          axisName = "Activities";
          break;
        case 1:
          axisName = "Countries";
          break;
        case 2:
          axisName = "Sites";
          break;
        default:
          axisName = "Activities";
          break;
      }

      return axisName;
    },
    getDataFromRadioButton(payload) {
      this.filter("country", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getDataFromCheckbox(payload) {
      this.filter("site", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },
    getParticipantsDataFromCheckbox(payload) {
      this.filter("participant", payload.isCheckAll ? "all" : payload);
    },
    fetchedParticipants(payload) {
      this.siteListInParticipants = payload;
    },
    getRangeMonth(payload) {
      this.filter("date", payload, payload.detailSite);
    },
    getSiteData(rawData, searchKeyword, filterKey = "name", responseKey = "userSiteId") {
      const siteData = _.find(rawData, allSitesWithDetails => {
        return allSitesWithDetails[filterKey] === searchKeyword;
      });
      return _.get(siteData, responseKey, "");
    },

    async filter(triggerBy, filterValue) {
      switch (triggerBy) {
        case "country":
          this.countrySelected = filterValue;
          const payloadQuery = {
            activities: {
              ...this.queriesRaw,
              ...this.activitiesRaw,
              ...this.overallCollectionMetricRaw
            },
            general: {
              ...this.queriesTimeRows,
              ...this.formStatusRaw,
              ...this.overallCollectionMetricParticipantRaw,
              ...this.overallMissingRaw,
              ...this.totalQuery
            }
          };

          const countrySelected = filterValue === "all" ? this.countryList : filterValue;
          let filteredSites = srv.getSitesByGeneralAndActivities(payloadQuery, countrySelected);
          this.sitesSelected = filterValue === "all" ? ["all"] : filteredSites;
          if (this.countrySelected && this.countrySelected.length === 0) {
            this.viewNoDataIn = true;
            // return;
          } else {
            this.viewNoDataIn = false;
          }
          break;
        case "site":
          this.sitesSelected = filterValue === "all" ? ["all"] : filterValue;
          if (this.sitesSelected && this.sitesSelected.length === 0) {
            this.viewNoDataIn = true;
            // return;
          } else {
            this.viewNoDataIn = false;
          }
          break;
        case "date": {
          this.monthSelected = filterValue;
          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;
          break;
        }
        case "participant": {
          this.participantsSelected = filterValue === "all" ? ["all"] : filterValue.checkedParticipants;
          if (this.participantsSelected && this.participantsSelected.length === 0) {
            this.setToEmptyData();
            return;
          }
          if (this.participantsSelected.length === 0) {
            this.overallCollectionMetricParticipantRaw = null;
          } else {
            this.getNewOverallCollectionParticipant(triggerBy).then(raws => {
              this.overallCollectionMetricParticipantRaw = raws;
            });
          }
          break;
        }
        default:
          break;
      }
      await this.callApi(true, triggerBy);
      this.filterTriggered = !this.filterTriggered;

      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;

      // Get value for queries open, queries response, and queries close
      this.queriesSeries = dManagement.GET_QUERIES_PERCENTAGE(this.queriesRaw, countrySelected, sitesSelected) || {};

      const docsTimeToActivities = ocm.GET_TIME_TO_ACTIVITY_STATUS(this.timeToActivitiesStatusCardRaw, this.countrySelected, this.sitesSelected, this.tabIndexTimeToActivities);
      this.timeToActivitiesStatusCardSeries = docsTimeToActivities;

      this.queriesData = srv.getQueriesData(this.queriesRaw, countrySelected, sitesSelected, this.tabQueries);
    },
    async prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];
      this.monthSelected = [firstMonth, lastMonth];
    },
    async getBrandingDetails() {
      try {
        const data = await this.$api.getBrandingDetailsFact(this.studyId);
        if (data.ok) {
          return data.body;
        } else {
          return null;
        }
      } catch (err) {
        return null;
      }
    },
    setToEmptyData() {
      this.queriesRaw = null;
      this.queriesTimeRows = null;
      this.activitiesRaw = null;
      this.formStatusRaw = null;
      this.overallCollectionMetricRaw = null;
      this.overallCollectionMetricParticipantRaw = null;
      this.overallMissingRaw = null;
    },
    async callApi(turnOffGlobalLoader = false, filterBy) {
      if (["mounted", "date"].includes(filterBy)) {
        this.getNewQueries(filterBy);
        this.getNewQueriesTime(filterBy);
        this.getNewActivities(filterBy);
        this.getNewFormStatus(filterBy);
        this.getNewOverallCollection(filterBy);
        this.getNewOverallCollectionParticipant(filterBy);
        this.getOverallMissingData(filterBy);
        this.getTotalQueryEndpoint(filterBy);
        this.getTotalDataChangeEndpoint(filterBy);
        this.getSiteDetails();
      }

      if (["site", "country"].includes(filterBy)) {
        this.getNewQueriesTime(filterBy);
      }
      if (["participant"].includes(filterBy)) {
        this.getNewActivities(filterBy);
        this.getNewQueries(filterBy);
        this.getNewQueriesTime(filterBy);
        this.getNewFormStatus(filterBy);
        this.getNewOverallCollection(filterBy);
        this.getNewOverallCollectionParticipant(filterBy);
        this.getOverallMissingData(filterBy);
        this.getTotalQueryEndpoint(filterBy);
        this.getTotalDataChangeEndpoint(filterBy)
      }

      if (["participant"].includes(filterBy)) {
        this.tmpCountries = this.newCountries;
        this.tmpSites = this.newSites;
      }
      this.callApiCompleted = true;
      if (turnOffGlobalLoader) {
        this.turnOffGlobalLoader();
      }
    },

    turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    },
    setNewQueriesData(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountriesByActivities(raws);
        const choosenCountries = countries;
        const sites = srv.getSiteByActivities(raws, choosenCountries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.queriesRaw = raws;
        this.dataLoaded.queriesRaw = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountriesByActivities(raws);
        const choosenCountries = countries;
        const sites = srv.getSiteByActivities(raws, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.queriesRaw = raws;
        this.dataLoaded.queriesRaw = true;
      }
    },
    setQueriesTimeData(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const choosenCountries = countries;
        const sites = srv.getSites(raws, choosenCountries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.queriesTimeRows = raws;
        this.dataLoaded.queriesTimeRows = true;
      }
      else if(raws && ["site", "country"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const choosenCountries = countries;
        const sites = srv.getSites(raws, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.queriesTimeRows = raws;
        this.dataLoaded.queriesTimeRows = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const choosenCountries = countries;
        const sites = srv.getSites(raws, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.queriesTimeRows = raws;
        this.dataLoaded.queriesTimeRows = true;
      }
    },
    setNewActivitiesData(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountriesByActivities(raws);
        const choosenCountries = countries;
        const sites = srv.getSiteByActivities(raws, choosenCountries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.activitiesRaw = raws;
        this.dataLoaded.activitiesRaw = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountriesByActivities(raws);
        const choosenCountries = countries;
        const sites = srv.getSiteByActivities(raws, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.activitiesRaw = raws;
        this.dataLoaded.activitiesRaw = true;
      }
    },
    setFormStatusData(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const choosenCountries = countries;
        const sites = srv.getSites(raws, choosenCountries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.formStatusRaw = raws;
        this.dataLoaded.formStatusRaw = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const choosenCountries = countries;
        const sites = srv.getSites(raws, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.formStatusRaw = raws;
        this.dataLoaded.formStatusRaw = true;
      }
    },
    setOverallColectionData(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountriesByActivities(raws);
        const choosenCountries = countries;
        const sites = srv.getSiteByActivities(raws, choosenCountries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.overallCollectionMetricRaw = raws;
        this.dataLoaded.overallCollectionMetricRaw = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountriesByActivities(raws);
        const choosenCountries = countries;
        const sites = srv.getSiteByActivities(raws, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.overallCollectionMetricRaw = raws;
        this.dataLoaded.overallCollectionMetricRaw = true;
      }
    },
    setOverallColectionParticipantData(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const choosenCountries = countries;
        const sites = srv.getSites(raws, choosenCountries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.overallCollectionMetricParticipantRaw = raws;
        this.dataLoaded.overallCollectionMetricParticipantRaw = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const choosenCountries = countries;
        const sites = srv.getSites(raws, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.overallCollectionMetricParticipantRaw = raws;
        this.dataLoaded.overallCollectionMetricParticipantRaw = true;
      }
    },
    setOverallColectionMissingData(raw, filterBy){
      if(raw && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountries(raw);
        const choosenCountries = countries;
        const sites = srv.getSites(raw, choosenCountries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.overallMissingRaw = raw;
        this.dataLoaded.overallMissingRaw = true;
      }
      else if(raw && ["participant"].includes(filterBy)){
        const countries = srv.getCountries(raw);
        const choosenCountries = countries;
        const sites = srv.getSites(raw, choosenCountries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.overallMissingRaw = raw;
        this.dataLoaded.overallMissingRaw = true;
      }
    },
    setTotalQueryData(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const sites = srv.getSites(raws, countries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.totalQuery = raws;
        this.dataLoaded.totalQuery = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const sites = srv.getSites(raws, countries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.totalQuery = raws;
        this.dataLoaded.totalQuery = true;
      }
    },
    setDataChange(raws, filterBy){
      if(raws && ["mounted", "date"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const sites = srv.getSites(raws, countries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.totalDataChange = raws;
        this.dataLoaded.totalDataChange = true;
      }
      else if(raws && ["participant"].includes(filterBy)){
        const countries = srv.getCountries(raws);
        const sites = srv.getSites(raws, countries);
        this.newCountries = this.newCountries.concat(countries);
        this.newSites = this.newSites.concat(sites);
        this.totalDataChange = raws;
        this.dataLoaded.totalDataChange = true;
      }
    }
  },

  watch: {
    tmpCountries: function(val) {
      const allCountries = _.uniq(val);
      this.countryList = _.orderBy(Array.from(allCountries), [country => country.toLowerCase()]);
    },

    tmpSites: function(val) {
      const allSites = _.uniq(val);
      this.allSitesList = _.orderBy(Array.from(allSites), [site => site.toLowerCase()]);
    },

    tabQueries: function(newValue) {
      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;
      this.queriesData = srv.getQueriesData(this.queriesRaw, countrySelected, sitesSelected, newValue);
    },

    queriesRaw: function(newValue) {
      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;

      this.queriesRaw = newValue;
      this.queriesSeries = dManagement.GET_QUERIES_PERCENTAGE(newValue, countrySelected, sitesSelected) || {};

      this.queriesData = srv.getQueriesData(newValue, countrySelected, sitesSelected, this.tabQueries);
    },

    activitiesRaw: function(newValue) {
      this.activitiesRaw = newValue;
    },

    formStatusRaw: function(newValue) {
      this.formStatusRaw = newValue;
    },

    queriesTimeRows: function(newValue) {
      const countrySelected = this.countrySelected === "all" ? this.countryList : this.countrySelected;
      const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;

      this.queriesTimeRows = newValue;
      this.queriesTimeSeries = dManagement.GET_QUERIES_TIME_DATA(newValue, countrySelected, sitesSelected);
    },

    overallMissingRaw: function(newValue) {
      this.overallMissingRaw = newValue;
    }
  },

  computed: {
    ...mapGetters(["user", "sitesData", "studyIdValue", "overallCollectionData", "overallCollectionParticipantData", "queriesList", "queriesTimeList", "activitiesData", "formStatusData", "overallCollectionMissingData", "totalQueryData", "totalDataChangeData"]),
    getSiteId() {
      return localStorage.getItem("selectedSite");
    },
    isSiteRole() {
      return commonHelper.isSiteUser(this.user.userRole);
    },
    checkCurrentSiteOrStudy() {
      return this.studyIdValue === this.studyId && (!this.isSiteRole || (this.isSiteRole && this.getSiteId === this.$store.state.selectedSiteId));
    }
  },

  async mounted() {
    this.$router.push({ query: { automatic_off_loader: false } });
    this.studyId = this.$route.params.studyId;
    await this.prepareDatePicker();
    this.specificSiteId = _get(this.user, "siteIds", []);
    const tabList = [
      { name: ACTIVITIES, visible: "12" },
      { name: COUNTRIES, visible }
    ];
    if (this.specificSiteId.length === 0) {
      tabList.push({ name: SITES, visible });
      this.tabListOverallQueryStatus.push(SITES);
      this.tabListActCountSit.push(SITES);
    }
    tabList.push({ name: PARTICIPANTS, visible });
    this.tabList = tabList;

    await this.callApi(true, "mounted");
  }
};
</script>
